export default __webpack_public_path__ + "static/media/tell-us-banner.54890583.png";